var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"fill":_vm.color,"fill-rule":"evenodd"}},[_c('path',{attrs:{"fill-rule":"nonzero","d":"M10.5 21C16.299 21 21 16.299 21 10.5S16.299 0 10.5 0 0 4.701 0 10.5 4.701 21 10.5 21zm0-1a9.5 9.5 0 1 1 0-19 9.5 9.5 0 0 1 0 19z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }